import { getEntityWithoutTypename } from "pages/utils";

export const handleSubmit = ({ createUser, history, currentCustomerId, contracts }) => values => {
  const userCustomerContracts = contracts
    .filter(contract => values.customerIds.includes(contract.customer_id))
    .map(c => c._id);

  if (userCustomerContracts.length === values.serviceContractsFilter.length) {
    values.serviceContractsFilter = [];
  }

  const updatedData = createUser({
    variables: {
      userInput: {
        ...getEntityWithoutTypename(values),
        confirmPassword: undefined,
      },
      customerId: currentCustomerId,
    },
  });

  return updatedData.then(result => {
    const user = result.data.createUser;
    if (user && user.username) {
      history.replace(`/user/details/${user.username}`);
    }
  });
};
